import type { EmbedSearchWidghetApiImportedVolopType } from '#/modules/embedSearchWidget/volops/api/types/EmbedSearchWidghetApiImportedVolopType';

export const VOLOP_IMPORTED_TYPE_MAP: Record<
  EmbedSearchWidghetApiImportedVolopType,
  string
> = {
  GOLDEN: 'Golden',
};
